export default __webpack_public_path__ + "static/media/planetdiscord.139ab5a2.png";